import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from "@mui/material/Tooltip";
// Others
import { utils } from '../../utils/utils';
import { VoucherTypes } from '../../models/VoucherTypes';
import { InvoiceTypeSelect } from '../../models/EnumEntity';

const Vouchers = ({ vouchers = [], handle, handleIsChange, icon = null, tooltip, keys = "" }) => {
    const renderVoucher = (voucher, isChange) => {
        const label = !isChange
            ? `${VoucherTypes.labels[voucher.type]} - ${utils.formatVoucherNumber(voucher.number)}`
            : `Ticket de cambio - ${utils.formatVoucherNumber(voucher.number)}`;

        const key = !isChange
            ? `${voucher.type}-${voucher.number}-${keys}`
            : `${voucher.type}-${voucher.number}-change-${keys}`

        const onClick = !isChange
            ? handle
            : handleIsChange

        return (
                <Tooltip title={tooltip} aria-label={tooltip}>
                    <MenuItem
                        key={key}
                        onClick={() => onClick(voucher)}
                        disabled={!voucher.isPrintable && !isChange}
                    >
                        {
                            icon && icon
                        }
                        <ListItemText primary={label} />
                    </MenuItem>
                </Tooltip>
        )
    }

    const menuItems = [
        ...vouchers.map(voucher => renderVoucher(voucher)),
        ...vouchers
            .filter(p => InvoiceTypeSelect.some(b => b.value === p.type))
            .map(voucher => renderVoucher(voucher, true))
            
    ]

    return menuItems.sort((a, b) => {
        if (a.key > b.key)
            return -1;

        if (a.key < b.key)
            return 1;

        return 0;
    })
}

export default Vouchers;